import { useEffect } from "react";
import { useNotification } from "./NotificationContext";
import { setNotifyInstance } from "./notify";

export const NotificationInitializer = () => {
  const notificationContext = useNotification();

  useEffect(() => {
    setNotifyInstance(notificationContext);
  }, [notificationContext]);

  return null;
};
